import React from 'react';
import './Photo.css'

const Photo = () => {
  return (
    <div>

        <div className="review">
    <div className="title_white">실제 포토 후기</div>
    <div className="subtitle">실제로 다녀온 회원님들의 후기입니다.</div>
    <div className="reviewbox">
      <div className="review_img">
        <img src="images/photo.jpg" alt="후기이미지" />
      </div>
      <header>
        <div className="icon">
          <img src="images/favorite.svg" alt="하트" />
        </div>
        <div className="mid">
        <h4>1,234</h4>
        <h5>#제주도 #야외 #촬영</h5>
      </div>
        <div className="insta">@Hye_Yeon</div>
      </header>
      <p>남자친구랑 제주도 여행가서 사진 하나 찍었어요!
        공기도 맑고 하늘도 이뻐서 매우 힐링되었답니다. 
        회원님들도 제주도 한 번 놀러가 보세요! </p>
    </div>
    <p><a href="#">다른 게시물 더 보러가기
    <img src="images/arrow.svg" alt="화살표" />
    </a></p>
  </div>
    </div>
  );
};

export default Photo;